import {
  TransportVehicleTypeQL,
  TransportVehicleType,
  AvailabilityOrderQL,
  AvailabilityOrder,
} from '@libs/trip-planner-interfaces';

import { mapEnumValue, isSameStringContent } from './utils';

export function toTransportVehicleType(
  vehicleQL: TransportVehicleTypeQL
): TransportVehicleType {
  if (!vehicleQL) {
    return TransportVehicleType.None;
  }

  return mapEnumValue(
    TransportVehicleTypeQL,
    TransportVehicleType,
    vehicleQL,
    (value) => isSameStringContent(value, vehicleQL)
  );
}

export function toAvailabilityOrder(
  availabilityOrderQL: AvailabilityOrderQL
): AvailabilityOrder {
  return mapEnumValue(
    AvailabilityOrderQL,
    AvailabilityOrder,
    availabilityOrderQL,
    (value) => isSameStringContent(value, availabilityOrderQL)
  );
}
